<template>
  <div class="skill-content">
    <template v-if="hasSections">
      <div
        v-for="(section, sectionIndex) in localSections"
        :key="`${section.name || 'section'}-${sectionIndex}`"
        class="skill-section"
      >
        <div class="">
          <section-title
            container-class=" mt-4 mb-4"
            :content="section.name"
            icon="fas fa-user text-orange"
            reverse
          />
        </div>

        <skill-question-row
          v-for="question in section.questions"
          :key="question.id"
          :answers="answers"
          :is-read-only="isReadOnly"
          :question="question"
          @input="updateQuestion(question, $event)"
        />
      </div>
    </template>

    <template v-else>
      <skill-question-row
        v-for="question in localQuestions"
        :key="question.id"
        :answers="answers"
        :is-read-only="isReadOnly"
        :question="question"
        @input="updateQuestion(question, $event)"
      />
    </template>
  </div>
</template>

<script>
import SkillQuestionRow from './SkillQuestionRow.vue';
import SectionTitle from '@/shared/components/SectionTitle.vue';

export default {
  name: 'SkillContent',
  components: {
    SkillQuestionRow,
    SectionTitle,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    answers: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    hasSections() {
      return (
        Array.isArray(this.model.sections) && this.model.sections.length > 0
      );
    },
    localSections() {
      return this.model.sections || [];
    },
    localQuestions() {
      return this.model.questions || [];
    },
  },
  methods: {
    updateQuestion(question, value) {
      question.selectedMainAnswerId = value.selectedMainAnswerId;
      question.selectedSupportAnswerId = value.selectedSupportAnswerId;
      question.observation = value.observation;
    },
  },
};
</script>

<style scoped>
.skill-section {
  margin-bottom: 1.5rem;
}

.skill-section__title {
  display: inline-flex;
  align-items: center;
  background: #efefef;
  border-radius: 999px;
  padding: 0.35rem 0.75rem;
  font-weight: 600;
  margin-bottom: 1rem;
}

.skill-section__icon {
  color: #ff7058;
  margin-right: 0.5rem;
}
::v-deep(.text-center) {
  background-color: #ffff;
}
</style>
